export default __webpack_public_path__ + "static/media/ZZC_7770.55cc7874.jpg";